module.exports = __webpack_public_path__ + "img/5.2cb0ad64.png";